export default __webpack_public_path__ + "31b6371e818d5517146be5c1415fb225.png";